"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
var _Icon2 = require("../../../Icon");
var _Icon3 = _interopRequireDefault(_Icon2);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
var IconPlaneTrip1 = /*#__PURE__*/
function (_Icon) {
  _inherits(IconPlaneTrip1, _Icon);
  function IconPlaneTrip1(props) {
    var _this;
    _classCallCheck(this, IconPlaneTrip1);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(IconPlaneTrip1).call(this, props));
    _this.name = 'IconPlaneTrip1';
    _this.icon = _react2.default.createElement("svg", {
      viewBox: "0 0 24 24",
      width: "1em",
      height: "1em",
      focusable: "false",
      "aria-hidden": "true",
      role: "presentation"
    }, _react2.default.createElement("g", {
      className: "plane-trip-1_svg__group0"
    }, _react2.default.createElement("path", {
      className: "plane-trip-1_svg__path0",
      d: "M17.134 23.868c-2.324 0-2.408-2.074-2.534-5.213-.053-1.305-.117-2.892-.331-4.715l-5.135 5.135v2.293c0 1.378-1.121 2.5-2.5 2.5-1.874 0-2.267-1.395-2.684-2.871-.068-.239-.136-.483-.214-.732-.271-.085-.537-.16-.775-.228-1.454-.412-2.827-.8-2.827-2.669 0-1.378 1.121-2.5 2.5-2.5h2.293l5.135-5.135c-1.823-.214-3.409-.277-4.705-.329C2.212 9.278.134 9.195.134 6.868c0-.785.218-1.382.666-1.828 1.043-1.036 3.164-1.203 7.837-1.203.911 0 1.916.006 3.022.013h.033c1.275.008 2.682.017 4.234.018L18.807.987a2.94 2.94 0 012.075-.85c.799 0 1.547.312 2.106.88l.011.011a2.959 2.959 0 01-.015 4.197l-2.851 2.851c.002 2.339.033 4.294.061 6.022.086 5.438.125 7.92-1.005 9.068-.471.479-1.124.702-2.055.702zm-2.5-11.5a.5.5 0 01.495.429c.329 2.305.407 4.252.47 5.817.139 3.448.297 4.254 1.535 4.254.654 0 1.068-.125 1.343-.405.836-.849.794-3.513.718-8.35a370.506 370.506 0 01-.061-6.246.5.5 0 01.146-.354l3-3a1.95 1.95 0 00.585-1.384 1.948 1.948 0 00-.586-1.409 1.945 1.945 0 00-1.395-.583c-.518 0-1.006.2-1.373.562l-3.023 3.023a.498.498 0 01-.354.146c-1.65 0-3.139-.009-4.481-.018a485.776 485.776 0 00-3.006-.013c-4.128 0-6.366.141-7.142.913-.253.251-.371.607-.371 1.118 0 1.24.808 1.398 4.263 1.536 1.565.063 3.511.141 5.807.469a.498.498 0 01.283.849l-6 6a.498.498 0 01-.354.146h-2.5c-.827 0-1.5.673-1.5 1.5 0 1.027.513 1.258 2.1 1.707.338.096.687.195 1.059.319.148.05.266.167.316.316.117.352.212.689.304 1.016.448 1.587.696 2.143 1.721 2.143.827 0 1.5-.673 1.5-1.5v-2.5a.5.5 0 01.146-.354l6-6a.512.512 0 01.355-.147z"
    })));
    return _this;
  }
  return IconPlaneTrip1;
}(_Icon3.default);
exports.default = IconPlaneTrip1;